import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Industries from "@/pages/Industries";

export const Route = createFileRoute("/es/industrias/")({
  head: () => buildRouteHead("/es/industrias"),
  component: Industries,
});

